import useHubSpotRTE from 'hubspot-prosemirror/prosemirror/useHubSpotRTE';
import { getBodyFieldEditorConfig } from '../components/ShareTool/BodyField';
export const useBodyValue = ({
  initialToContactValue,
  bodyValueParam
}) => {
  const editorConfig = getBodyFieldEditorConfig(initialToContactValue);
  const [initialBodyEditorState] = useHubSpotRTE(bodyValueParam, editorConfig);
  const [bodyEditorState, setBodyEditorState] = useHubSpotRTE(bodyValueParam, editorConfig);
  return {
    bodyValue: bodyEditorState,
    setBodyValue: setBodyEditorState,
    initialBodyValue: initialBodyEditorState
  };
};